module.exports = "<div class=\"page\" style=\"text-transform: uppercase !important;\">\n  <div class=\"page-content w-100 mw-900 shadow no-p\">\n    <div class=\"form-header p-2\">\n      <h2>Expediente Digital y Cotejo</h2>\n    </div>\n    <app-commerce-casefile-form [showCotejo]=\"true\"></app-commerce-casefile-form>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page/casefile-cotejo-page/casefile-cotejo-page.component.html
// module id = 1150
// module chunks = 0